import React from 'react'
import { CSSProperties } from "react";
import { XYCoord, useDragLayer } from "react-dnd";
import { useSelector } from "react-redux";
import { ItemTypes } from "../../Common/Components/ItemTypes";
import { WFStatus, WFStatusEnum } from "../interfaces";
import Action from './Action';
import { RootState } from "store";

const layerStyles: CSSProperties = {
  position: "fixed",
  pointerEvents: "none",
  zIndex: 100,
  left: 0,
  top: 0,
  width: "248px",
  height: "100%",
};

function getItemStyles(initialOffset: XYCoord | null, currentOffset: XYCoord | null) {
  if (!initialOffset || !currentOffset) {
    return {
      display: "none",
    };
  }

  let { x, y } = initialOffset;

  const transform = `translate(${x - 35}px, ${y - 15}px)`;
  //const transform = `rotate(-10deg)`
  return {
    transform,
    WebkitTransform: transform,
  };
}

export default function AutomationDragLayer() {
  const workflowStatus: WFStatus = useSelector((state: RootState) => state.automation.workflow?.detail?.status);
  const { itemType, isDragging, item, initialOffset, currentOffset } = useDragLayer((monitor) => {
    return {
      item: monitor.getItem(),
      itemType: monitor.getItemType(),
      initialOffset: monitor.getClientOffset(),
      currentOffset: monitor.getSourceClientOffset(),
      isDragging: monitor.isDragging(),
    };
  });

  function renderItem() {
    switch (itemType) {
      case ItemTypes.CARD:
        return (<Action
          name={item.controlName}
          title={item.title}
          controlId={item.controlId}
          controlType={item.controlType}
          isNodeCopied={false}
          preview
        />);
      default:
        return null;
    }
  }

  // if element/control is not dragging and if it is dragging then the status should not "draft" to return nothing 
  // from this component 
  if (!isDragging || (isDragging && workflowStatus !== WFStatusEnum.DRAFT)) {
    return null;
  }

  return (
    <div style={layerStyles}>
      <div id="box-drag-preview" style={getItemStyles(initialOffset, currentOffset)}>
        {renderItem()}
      </div>
    </div>
  );
}
